"use strict";
/**
 * Created by marvinruppelt on 02.06.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
var BaseColumn_1 = __importDefault(require("./BaseColumn"));
var BoolColumn = function (_a) {
    var name = _a.name, rowData = _a.rowData, idx = _a.idx, _b = _a.withNull, withNull = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? 'symbol' : _c, rest = __rest(_a, ["name", "rowData", "idx", "withNull", "type"]);
    var value = (0, find_in_object_1["default"])(idx, rowData);
    var isTrue = [true, 'true', 1, '1', 'j', 'J'].indexOf(value) !== -1;
    var isFalse = !withNull
        ? !isTrue
        : [false, 'false', 0, '0', 'n', 'N'].indexOf(value) !== -1;
    if (type == 'string') {
        return (react_1["default"].createElement(BaseColumn_1["default"], __assign({}, rest, { rowData: rowData, idx: idx }), isTrue
            ? react_1["default"].createElement("span", null, "ja")
            : (isFalse
                ? react_1["default"].createElement("span", null, "nein")
                : null)));
    }
    // else: type == symbol
    return (react_1["default"].createElement(BaseColumn_1["default"], __assign({}, rest, { rowData: rowData, idx: idx }), isTrue === true
        ? react_1["default"].createElement(react_symbol_1["default"], { symbol: { symbol: "check", className: "text-success" } })
        : (isFalse === true
            ? react_1["default"].createElement(react_symbol_1["default"], { symbol: { symbol: "times", className: "text-danger" } })
            : null)));
};
exports["default"] = BoolColumn;
